import {DashboardTilePlacement} from '../types/DashboardTilePlacement';
import {PositionedDashboardGridTile} from './allocateDashboardGrid';

export function applyDashboardGridLayout(
  placements: DashboardTilePlacement[],
  positionedTiles: PositionedDashboardGridTile[]
): DashboardTilePlacement[] {
  return placements.map((placement) => {
    const positioned = positionedTiles.find((tile) => tile.id === placement.id);

    return positioned === undefined
      ? placement
      : {
          ...placement,
          size: positioned.size,
          column: positioned.column,
          row: positioned.row,
        };
  });
}
